import React from 'react';
import { NavButton } from 'components/Buttons/NavButton';

import styles from './styles.module.scss';
import { Alert, AlertTitle } from '../../../../components/Alert';
import { AlertColor } from '@mui/material/Alert/Alert';
import { EditDocumentTypeMenu } from '../../EditDocumentType/EditDocumentTypeMenu';
import { IDocument } from '../../../../common/document/interfaces/document';

type InputProps = {
  title: string;
  titlePrev: string;
  titleNext: string;
  onPrev: () => void;
  onNext: () => void;
  notifications: {
    message: string;
    type: AlertColor;
  }[];
  canEditDocumentType?: boolean;
  document: IDocument;
};

export const DocumentReviewHeader = ({
  title,
  titlePrev,
  titleNext,
  onPrev,
  onNext,
  notifications,
  canEditDocumentType = false,
  document,
}: InputProps) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.goBack}>
          {titlePrev && (
            <NavButton arrowDirection="left" onClick={onPrev}>
              {titlePrev}
            </NavButton>
          )}
        </div>
        <div className={styles.title}>
          <span
            data-test-id={`review-modal-document-title-${document.documentType}`}
          >
            {title}
          </span>
          {canEditDocumentType && (
            <EditDocumentTypeMenu
              documentId={document.candidateDocumentId}
              currentDocument={{
                name: title,
                documentType: document.documentType,
              }}
            />
          )}
        </div>
        <div className={styles.goBack}>
          {titleNext && (
            <NavButton arrowDirection="right" onClick={onNext}>
              {titleNext}
            </NavButton>
          )}
        </div>
      </div>
      {notifications.map((notification) => (
        <Alert key={notification.message} severity={notification.type}>
          <AlertTitle>{notification.message}</AlertTitle>
        </Alert>
      ))}
    </div>
  );
};
